export type BrowserLocale = 'fr' | 'en';

/**
 * Maps a browser language tag to the display locale of the website.
 * Any French tag (fr, fr-FR, fr-BE, fr-CH, fr-CA...) gives `fr`; every other value, empty or missing, gives `en`.
 * The user country is not part of the rule: only the browser language counts.
 * @param language - browser language tag, `navigator.language` by default
 * @returns `fr` or `en`
 */
export const getBrowserLocale = (language: string | null | undefined = navigator.language): BrowserLocale => {
  const primaryTag = language?.trim().split('-')[0].toLowerCase();
  return primaryTag === 'fr' ? 'fr' : 'en';
};
